module.exports = __webpack_public_path__ + "img/zero-logo-dark.fd7fb1ed.svg";